'use client'
import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';

const API_URL = '/api';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [backgroundImage, setBackgroundImage] = useState('/images/background1.webp');
  const router = useRouter();

  console.log('Login page rendered'); // Log inicial para verificar que la página se carga
  
  // Seleccionar una imagen de fondo aleatoria al cargar
  useEffect(() => {
    const backgrounds = [
      '/images/background1.webp',
      '/images/background2.webp'
    ];
    const randomIndex = Math.floor(Math.random() * backgrounds.length);
    setBackgroundImage(backgrounds[randomIndex]);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted', { email }); // Log al enviar el formulario

    try {
      console.log('Attempting login...', API_URL);
      console.log('Intentando login con:', { 
        username: email.trim(), 
        password: password 
      });
      const loginResponse = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: email.trim(), password })
      });
   
      console.log('Login response:', loginResponse.status);
      const loginData = await loginResponse.json();

      if (loginResponse.ok) {
        localStorage.setItem('token', loginData.token);
        localStorage.setItem('userId', loginData.user.id);
        
        // Obtener compañías
        console.log('Fetching companies...');
        const response = await fetch(`${API_URL}/auth/companies`, {
          headers: { 'Authorization': `Bearer ${loginData.token}` }
        });
        const companies = await response.json();
        console.log('Companies:', companies);

        if (companies.length > 1) {
          router.push('/select-company');
        } else if (companies.length === 1) {
          localStorage.setItem('selectedCompany', companies[0]._id);
          router.push('/select-site');
        }
      } else {
        setError(loginData.message || 'Error de autenticación');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Error de conexión');
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center">
      {/* Imagen de fondo */}
      <div className="absolute inset-0 z-0">
        <img 
          src={backgroundImage} 
          alt="Background" 
          className="w-full h-full object-cover"
        />
      </div>
      
      {/* Formulario de login */}
      <div className="bg-white p-8 rounded-lg shadow-md w-96 z-10 relative">
        <h1 className="text-2xl font-bold mb-6 text-center">Login</h1>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 border rounded"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-2 border rounded"
              required
            />
          </div>
          {error && (
            <p className="text-red-500 text-sm mb-4">{error}</p>
          )}
          <button
            type="submit"
            className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
          >
            Iniciar Sesión
          </button>
        </form>
      </div>
    </div>
  );
}